<template>
  <div v-if="alertMessage.message !== ''">
    <Message closable role="alert" class="mb2" :severity="alertMessage.severity">
      {{ alertMessage.message }}
    </Message>
  </div>
  <div v-if="isLoggedIn">
    <p>{{ domainStore.translate('user.login.already-logged-in', { name: user.public_name }) }}</p>
  </div>
  <div v-else>
    <Form @submit="onSubmitPasswordRequest">
      <div id="wdw-passwordrequest-form" class="wdw-form">
        <form-control-input
          :label="domainStore.translate('user.form.label.email')"
          type="email"
          name="email"
          code="email"
          :required="true"
          :help="domainStore.translate('user.form.message.email-login-help')"
          parentFormId="wdw-passwordrequest-form"
        />
        <button type="submit" class="btn btn-primary btn-form-submit" :disabled="loading" name="submit">
          {{ domainStore.translate('user.password.renew.submit') }}
        </button>
        &nbsp;
        <button
          type="button"
          class="btn btn-default btn-form-cancel"
          :disabled="loading"
          name="cancel"
          @click="emitClose()"
        >
          {{ domainStore.translate('user.form.cancel') }}
        </button>
        <vue-loading v-if="loading" />
      </div>
    </Form>
  </div>
</template>

<script>
import { userStore } from '@/store/user-store';
import { domainStore } from '@/store/domain-store';
import { reactive, ref, computed } from 'vue';
import { RepositoryFactory } from '@/api/repositoryFactory';
const AuthRepository = RepositoryFactory.get('auth');

import FormControlInput from '@/components/general/FormControl/Input';
import { Form } from 'vee-validate';
import VueLoading from '@/components/general/Loading';
import Message from 'primevue/message';
// TODO
// test & finish implementation
// integrate in workflow correctly

export default {
  name: 'RequestPassword',
  props: {
    domainid: {
      type: Number,
      required: true,
    },
  },
  emits: ['close'],

  setup(props, context) {
    const loading = ref(false);
    const alertMessage = reactive({
      message: '',
      severity: 'alert-warning',
    });

    //computed
    const user = computed(() => {
      return userStore.getState().user;
    });
    const isLoggedIn = computed(() => {
      return userStore.isLoggedIn();
    });

    function emitClose(message) {
      console.log('emitting close');
      context.emit('close', message);
    }

    const onSubmitPasswordRequest = (values, actions) => {
      loading.value = true;
      alertMessage.message = '';

      AuthRepository.requestPassword(values.email)
        .then(response => {
          loading.value = false;
          emitClose(domainStore.translate('user.password.message.renew-success', { email: values.email }));
        })
        .catch(error => {
          loading.value = false;
          alertMessage.message = domainStore.translate('user.password.message.renew-error', { email: values.email });
        });
    };

    return {
      domainStore,
      user,
      isLoggedIn,
      onSubmitPasswordRequest,
      emitClose,
      loading,
      alertMessage,
    };
  },

  components: {
    FormControlInput,
    Form,
    VueLoading,
    Message,
  },
};
</script>

<style scoped></style>
